export const IS_ON_DESKTOP_MEDIA_QUERY = "(min-width: 961px)";
export const IS_ON_MOBILE_MEDIA_QUERY = "(max-width: 960px)";
export const IS_ON_SMALL_DESKTOP_MEDIA_QUERY =
  "(min-width: 961px) and (max-width: 1024px)";
